import React from 'react';
import { useSelector } from 'react-redux';

import { SkeletonTable } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const Services = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Quotation.Show']
  );

  if (StateLoading) {
    return <SkeletonTable headerCount={5} bodyCount={5} />;
  }

  return (
    <section id="services">
      {data?.services.map((s, k) => (
        <>
          <div className='border rounded-2 mb-2' key={k}>
            <div class="px-3 py-2">
              <div class="fw-bold">{k+1}. {`${s?.service?.name} - ${s?.service_type?.name}`}</div>
              {s?.rfq && (
                <small class="ms-3 mt-2 fs-8">{s?.rfq?.join(',')}</small>
              )}
            </div>
            <div className="table-responsive m-0">
              <table
                width="100%"
                className="table table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td style={{ whiteSpace: 'initial', width: '130px' }}>
                      Service
                    </td>
                    <td style={{ whiteSpace: 'initial', width: '150px' }}>
                      Unit Type
                    </td>
                    <td style={{ whiteSpace: 'initial', width: '150px' }}>
                      Origin
                    </td>
                    <td style={{ whiteSpace: 'initial', width: '150px' }}>
                      Destination
                    </td>
                    <td style={{ whiteSpace: 'initial', width: '100px' }}>
                      Tarif/{s?.service?.name === 'Distribution' ? 'KG': 'Unit'}
                    </td>
                    <td style={{ whiteSpace: 'initial', width: '130px' }}>
                      Remarks
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {s?.routes?.map((r, i) => (
                    <tr key={i}>
                      <td style={{ whiteSpace: 'initial', width: '130px' }}>
                        {s?.service_type?.name}
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '150px' }}>
                        {r?.vehicle_type?.karoseri_type !== '' ? `${r?.vehicle_type?.karoseri_type} - ${r?.vehicle_type?.name}`: r?.vehicle_type?.name}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '150px' }}>
                        {r?.origin}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '150px'}}>
                        {r?.destination}
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '100px' }}>
                        {currencyFormat(r?.unit_price)}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '130px' }}>
                        {r?.remarks}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="table-responsive m-0">
              <table
                width="100%"
                className="table table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td style={{ whiteSpace: 'initial'}}>
                      Service Note
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ whiteSpace: 'pre-wrap', width: '130px' }}>
                      {s?.note}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      ))}
    </section>
  );
};
